import { render } from "./profitability-report.vue?vue&type=template&id=87b56554&scoped=true"
import script from "./profitability-report.vue?vue&type=script&lang=js"
export * from "./profitability-report.vue?vue&type=script&lang=js"

import "./profitability-report.vue?vue&type=style&index=0&id=87b56554&scoped=true&lang=css"

import exportComponent from "/home/runner/work/inventflux-frontend/inventflux-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-87b56554"]])

export default __exports__